import { createSlice } from '@reduxjs/toolkit';
import { CompaniesStore } from './store';
export const slice = createSlice({
    name: '@@COMPANIES',
    initialState: CompaniesStore.empty(),
    reducers: (create)=>({
            load: create.reducer((state)=>CompaniesStore.load()(state)),
            putAll: create.reducer((_, { payload: companies })=>CompaniesStore.putAll(companies)()),
            added: create.reducer((state, { payload: company })=>CompaniesStore.added(company)(state)),
            updated: create.reducer((state, { payload: company })=>CompaniesStore.updated(company)(state)),
            removed: create.reducer((state, { payload: companyId })=>CompaniesStore.removed(companyId)(state))
        })
});
